import { cloneDeep } from "lodash";

export const StartOfMonth = (date: Date) => {
  const firstDayOfMonth = cloneDeep(date);
  firstDayOfMonth.setDate(1);
  return firstDayOfMonth;
};
